import { render, staticRenderFns } from "./dangerJournalItem.vue?vue&type=template&id=3396d4e6"
import script from "./dangerJournalItem.vue?vue&type=script&lang=js"
export * from "./dangerJournalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3396d4e6')) {
      api.createRecord('3396d4e6', component.options)
    } else {
      api.reload('3396d4e6', component.options)
    }
    module.hot.accept("./dangerJournalItem.vue?vue&type=template&id=3396d4e6", function () {
      api.rerender('3396d4e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerJournalItem.vue"
export default component.exports